<template>
    <div class="productListBox">
       <el-table :data="tableData" border @row-click="goToProductInfo">
            <el-table-column prop="industry" label="所属行业" ></el-table-column>
            <el-table-column prop="productName" label="产品名称" ></el-table-column>
        </el-table>
    </div>
</template>

<script>
  import {mapState} from 'vuex'
  import ssUtil from '@/utils/SStorage'

  export default {
    name: 'companyList',
    data() {
        return {
            tableData: []
        }
    },
    computed:{...mapState(['indexSearchInfo'])},
    created(){
        this.indexSearchInfo.forEach( item => {
            let params = {}
            params.productName =  item.productName;
            params.industry =  item.industry;
            params.productCode =  item.productCode;
            this.tableData.push(params);
        });
    },
    methods: {
        //点击相应公司或者股票代码跳转至产品页
        goToProductInfo(row){
          let params = {
                type: 'product',
                name:row.productName,
                industry:row.industry,
                productCode:row.productCode
            }
            this.$router.push({name:'productInfo',params:params})
        },

    },
    mounted() {

    }
  }
</script>

<style lang="scss" src="../sass/productList.scss"></style>



// WEBPACK FOOTER //
// src/components/productList.vue